import React from 'react';
import PropTypes from 'prop-types';

import styles from '../collegeProspectTab.scss';

const AcademicsFormField = ({ label, testId, testIdPrefix, children }) => (
    <label
        className={styles.academicsEditField}
        data-testid={`${testIdPrefix}.${testId}-label`}
    >
        <span data-testid={`${testIdPrefix}.${testId}-label.text`}>
            {label}
        </span>
        {children}
    </label>
);

AcademicsFormField.propTypes = {
    label: PropTypes.node.isRequired,
    testId: PropTypes.string.isRequired,
    testIdPrefix: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};

export default AcademicsFormField;
